// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Swiper from 'swiper/js/swiper';

const fragments = {
	SWIPER: '[data-fragment="LunchListingSlider.swiper"]',
	PREV: '[data-fragment="LunchListingSlider.prev"]',
	NEXT: '[data-fragment="LunchListingSlider.next"]',
};

class LunchListingSlider extends WebComponent {
	constructor (props) {
		super(props);
	}

	didMount() {
		this.swiperElement = this.element.querySelector(fragments.SWIPER);
		this.swipers = new Swiper(this.swiperElement, {
			speed: 500,
			loop: false,
			slidesPerView: 1,
			grabCursor: true,
			navigation: {
				nextEl: fragments.NEXT,
				prevEl: fragments.PREV,
			},
		});
	}
	willUnMount() {}
	update() {}
}
export default LunchListingSlider;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/LunchListingSlider.js